import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnChanges, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Choice, FilterDefinition } from '@model';
import { TranslateService } from '@ngx-translate/core';
import { CustomCalendarHeaderComponent } from '@core/components';
import { FilterType } from '@enums';
import { X } from '@angular/cdk/keycodes';

export class FilterWrapper {
  filterDefinitions: FilterDefinition[] = [];
}
@Component({
    selector: 'app-filter-pane',
    templateUrl: './filter-pane.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class FilterPaneComponent implements OnInit, OnChanges {

  filterDefinitions: FilterDefinition[] = [];

  constructor(
    private translate: TranslateService,
    private changeDetectorRef: ChangeDetectorRef,
    public dialogRef: MatDialogRef<FilterPaneComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { definitions: FilterDefinition[] }
  ) {
    this.filterDefinitions = data.definitions; // all filters to display...
  }

  ngOnInit(): void {
  }

  ngOnChanges(): void {
  }

  onFilterChanged = (updatedFilter: FilterDefinition) => {
    this.filterDefinitions = this.filterDefinitions.map(f =>
      f.filterId === updatedFilter.filterId
        ? updatedFilter
        : f
    );
  };

  clearFilter = () => {
 
    let filterDefinitionsView = JSON.parse(JSON.stringify(this.filterDefinitions));

    filterDefinitionsView.forEach(filter => {
      switch (filter.filterType) {
          case FilterType.MultiChoice:
            filter.multiChoiceFilter.selected = [];
            filter.multiChoiceFilter.selections = this.clearSelections(filter.multiChoiceFilter.selections);
            filter.selected = [];
            break;
          case FilterType.SingleCoice:
            filter.singleChoiceFilter.selected = null;
            filter.selected = null;
            break;
          case FilterType.ValueRange:
            filter.valueRangeFilter.selected = [];
            filter.selected = [];
            filter.valueRangeFilter.fromValue = null;
            filter.valueRangeFilter.toValue = null;
            break;
          case FilterType.DateRange:
            filter.dateFilter.selected = [];
            filter.selected = [];
            filter.dateFilter.dayDateFrom = null;
            filter.dateFilter.dayDateTo = null;
            break;
          case FilterType.CheckBox:
            filter.checkBoxFilter.selection.selected = false;
            filter.checkBoxFilter.selected = [];
            filter.selected = [];
            break;
          default:
            return filter;
      }
    });
  
    this.filterDefinitions = JSON.parse(JSON.stringify(filterDefinitionsView));
    this.changeDetectorRef.markForCheck();
  };

   // selected contains list of names
   clearSelections(_selections: Choice[]): Choice[] {
    let tmpSelections: Choice[] = [];
    _selections?.forEach(o => {
          let choice = {
            name: o.name,
            value: o.value,
            selected: false
          } as Choice;
          tmpSelections.push(choice);
    });
    return tmpSelections;
  }


  onFilter(): void {
    this.dialogRef.close(this.filterDefinitions);
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
